(function(){
  function pad(n){return String(n).padStart(2,'0')}
  function tick(){
    document.querySelectorAll('[data-oz-end]').forEach(function(el){
      var end=Date.parse(el.getAttribute('data-oz-end'));
      if(isNaN(end)) return;
      var ms=end-Date.now();
      var root=el.closest('[data-oz-countdown-root]')||el;
      if(ms<=0){root.hidden=true;return}
      var d=Math.floor(ms/864e5),h=Math.floor(ms%864e5/36e5),m=Math.floor(ms%36e5/6e4);
      var c=el.querySelectorAll('b');
      if(c.length===3){c[0].textContent=pad(d);c[1].textContent=pad(h);c[2].textContent=pad(m)}
      else{el.textContent=pad(d)+' j '+pad(h)+' h '+pad(m)+' min'}
    });
  }
  function init(){
    tick(); setInterval(tick,30000);
    document.querySelectorAll('[data-oz-open]').forEach(function(b){
      b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('data-oz-open'));if(d&&d.showModal)d.showModal()});
    });
    document.querySelectorAll('[data-oz-close]').forEach(function(b){
      b.addEventListener('click',function(){var d=b.closest('dialog');if(d)d.close()});
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
